import React from "react";
import Gif from "../../../imgs/htmlAdvert5/yanaeadvert.gif";
//id 215 216
export const HTMLAdvert5 = ({hide, onClick}) => {
  return !hide && (
    <div className="yanae">
      <img src={Gif} alt="Yanae" />
      <a
        className="sign-up-button"
        href="https://www.consilienthealth.ie/meetings-and-yanae-training/?utm_source=gpconsult&utm_medium=gpconsult&utm_campaign=gpconsult"
        target="_blank"
        rel="noopener"
        onClick={onClick}></a>
      <a
        className="ifu"
        href="https://www.consilienthealth.ie/yanae/wp-content/uploads/sites/3/2025/12/yanae-ifu.pdf?utm_source=gpconsult&utm_medium=gpconsult&utm_campaign=gpconsult"
        target="_blank"
        rel="noopener"
        onClick={onClick}></a>
    </div>
  );
};